import { collection, doc, CollectionReference } from 'firebase/firestore'
import { firestoreService as firestoreServiceOld } from '@/utils/firestoreServiceOld'
import { firestoreService as firestoreServiceNew } from '@/utils/firestoreService'
import { db } from '@/firebase/config'
import { type TransactionRecord } from '@/types/Transaction'
import { buildCollectionPath } from '@/utils/firestoreService'

const COLLECTION = 'transaction_records'

export async function fetchTransaction(id: string) {
  const collectionPath = await buildCollectionPath(COLLECTION)
  const colRef: CollectionReference = collection(db, collectionPath)
  return await firestoreServiceOld.get(doc(colRef, id))
}

export async function fetchTransactionsByPersonId(personId: string) {
  const collectionPath = await buildCollectionPath(COLLECTION)
  const colRef: CollectionReference = collection(db, collectionPath)
  return await firestoreServiceOld.query<TransactionRecord>(colRef, [['personId', '==', personId]])
}

export async function countTransactionsByPersonId(personId: string) {
  return await firestoreServiceNew.count(COLLECTION, [
    {
      field: 'personId',
      op: '==',
      value: personId,
    },
  ])
}

export async function fetchTransactionsByOrganizationId(organizationId: string) {
  const collectionPath = await buildCollectionPath(COLLECTION)
  const colRef: CollectionReference = collection(db, collectionPath)
  return await firestoreServiceOld.query<TransactionRecord>(colRef, [
    ['organizationId', '==', organizationId],
  ])
}

export async function countTransactionsByOrganizationId(organizationId: string) {
  return await firestoreServiceNew.count(COLLECTION, [
    {
      field: 'organizationId',
      op: '==',
      value: organizationId,
    },
  ])
}

export async function fetchAllTransactions() {
  const collectionPath = await buildCollectionPath(COLLECTION)
  const colRef: CollectionReference = collection(db, collectionPath)
  return await firestoreServiceOld.list(colRef)
}

export async function createTransaction(data: TransactionRecord) {
  const collectionPath = await buildCollectionPath(COLLECTION)
  const colRef: CollectionReference = collection(db, collectionPath)
  return await firestoreServiceOld.add(colRef, data)
}

export async function updateTransaction(id: string, data: Partial<TransactionRecord>) {
  const collectionPath = await buildCollectionPath(COLLECTION)
  const colRef: CollectionReference = collection(db, collectionPath)
  return await firestoreServiceOld.update(doc(colRef, id), data as Partial<TransactionRecord>)
}

export async function deleteTransaction(id: string) {
  const collectionPath = await buildCollectionPath(COLLECTION)
  const colRef: CollectionReference = collection(db, collectionPath)
  return await firestoreServiceOld.delete(doc(colRef, id))
}

export async function fetchPurchaseTransactionsByDateRange(startDate: Date, endDate: Date) {
  return await firestoreServiceNew.query<TransactionRecord>('transaction_records', [
    {
      field: 'transaction_date',
      op: '>=',
      value: startDate,
    },
    {
      field: 'transaction_date',
      op: '<=',
      value: endDate,
    },
    {
      field: 'transaction_type',
      op: '==',
      value: 'purchase',
    },
  ])
}
